import React from "react";
import styled from "@emotion/styled";
import { ForestModalBase } from "./ForestModalBase";

const Info = styled.div`
  padding: 32px 24px;
  background-color: ${({ theme }) => theme.colors.mushroomLight};
`;

const InfoLink = styled.a`
  color: ${({ theme }) => theme.colors.charcoal};

  &:hover {
    color: ${({ theme }) => theme.colors.jungle};
  }
`;

const InfoParagraph = styled.p`
  font-size: 16px;
  margin-bottom: 16px;
`;

const InfoTitle = styled.h2`
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 12px;
  margin-top: 0;
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 32px;
  color: ${({ theme }) => theme.colors.charcoal};
`;

export const ForestModalInvestor = ({
  closePopup,
  isOpen,
}: {
  closePopup: () => void;
  isOpen: boolean;
}) => {
  return (
    <ForestModalBase
      closePopup={closePopup}
      imagePath="/images/app/forest/investor-modal.png"
      isOpen={isOpen}
    >
      <div>
        <Title>Investor impact</Title>
        <Info>
          <InfoTitle>What's this?</InfoTitle>
          <InfoParagraph>
            The owner of this profile has taken part in one of our crowdfunding
            campaigns and invested in Ecologi.
          </InfoParagraph>
          <InfoParagraph>
            {`Follow `}
            <InfoLink
              href="https://www.crowdcube.com/explore-companies/ecologi"
              target="_blank"
              rel="noopener noreferrer"
            >
              this link
            </InfoLink>
            {` to see more about Ecologi's crowdfunding campaigns.`}
          </InfoParagraph>
          <img
            src="/images/app/forest/investor-heart-icon.svg"
            alt=""
            width="28"
            height="25"
          />
        </Info>
      </div>
    </ForestModalBase>
  );
};
